var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detaiBox"},[_c('headTotal'),_c('div',{staticClass:"detailContainer"},[(_vm.gameInfoShow)?_c('detail',{attrs:{"row":_vm.row}}):_vm._e(),(_vm.jiaochengShow)?_c('detailJc',{attrs:{"row":_vm.row}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }